import React from "react";
import Layout from "../../Components/Layout";
// import MyPromotingEvents from "../../Components/Promoter/MyPromotingEvents";
import MyPromotingEvents from "../../Components/OrderMgt/Promoter/MyPromotingEvents";

const MyPromotingEventsPage = () => {
  return (
    <Layout
      Heading="My Promoting Events"
      TitleMark="My"
      TitleMarkClassName="event-promoting-title-mark"
      TitleClassName="event-promoting-title"
      HeadClassName="event-promoting-head"
      ExtraclassName="event-promoting-panel"
      activeMenuId="my-promoting-events"
    >
      <MyPromotingEvents />
    </Layout>
  );
};

export default MyPromotingEventsPage;
